export const eventCategory = "CARS24_offer_page";
export const eventCategoryPickup = "Pickup_screen";
export const eventCategoryHandover = "Car_handover_screen";

export const viewDetailPartyPeshi = {
    event: "view_details_click_party_peshi",
    eventAction: "view details clicked on Party Peshi section",
    eventCategory
};

export const viewDetailNoc = {
    event: "view_details_click_noc",
    eventAction: "view details clicked on NOC section",
    eventCategory
};

export const viewDetailPartyPeshiPickup = {
    event: "view_details_click_party_peshi_pickup",
    eventAction: "view details clicked on Party Peshi section",
    eventCategoryPickup
};

export const viewDetailNocPickup = {
    event: "view_details_click_noc_pickup",
    eventAction: "view details clicked on NOC section",
    eventCategoryPickup
};

export const viewDetailPartyPeshiHandover = {
    event: "view_details_click_party_peshi_car_handover",
    eventAction: "view details clicked on Party Peshi section",
    eventCategoryHandover
};

export const viewDetailNocHandover = {
    event: "view_details_click_noc_car_handover",
    eventAction: "view details clicked on NOC section",
    eventCategoryHandover
};
